import App from './App.svelte';
import './global.css';  // global.css로 변경

const app = new App({
  target: document.body
});

export default app;